import { computed } from 'vue';
import { ACCEPT_PAYMENTS, VIEW_CLAIMS } from '@/common/permissionConstants';
import { useFeatureFlags } from '@/composables/useFeatureFlags';
import { useAuthStore } from '@/stores/auth';

/**
 * The Billing page's tabs in display order. Each is a child route of /billing; `flag` and
 * `permission` gate it the way its older screen is gated, and Charges has neither.
 */
export const BILLING_TABS = [
    { name: 'billing-charges', label: 'Charges', flag: null, permission: null },
    { name: 'billing-remittances', label: 'Remittances', flag: 'availity-claims', permission: VIEW_CLAIMS },
    { name: 'billing-payments', label: 'Payments', flag: 'fortis-payments', permission: ACCEPT_PAYMENTS },
    { name: 'billing-activity', label: 'Activity', flag: 'patient-ledger', permission: ACCEPT_PAYMENTS },
    { name: 'billing-files', label: 'Files', flag: 'availity-claims', permission: VIEW_CLAIMS },
];

/** Whether this session may see the tab: its flag is on and the user holds its permission. */
export function isBillingTabAvailable(tab) {
    const { isEnabled } = useFeatureFlags();
    return (!tab.flag || isEnabled(tab.flag)) && (!tab.permission || useAuthStore().hasPermission(tab.permission));
}

/**
 * The Billing tabs this session may see, in BILLING_TABS order.
 *
 * @returns {{ tabs: import('vue').ComputedRef<typeof BILLING_TABS> }}
 */
export function useBillingTabs() {
    const tabs = computed(() => BILLING_TABS.filter(isBillingTabAvailable));
    return { tabs };
}
